var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.61,
    height: 17.2,
    viewBox: "0 0 17.61 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109504",
    "data-name": "Path 109504",
    d: "M2,10.581c0-3.1,0-4.653.961-5.617S5.47,4,8.564,4h3.282c3.094,0,4.642,0,5.6.964s.961,2.515.961,5.617v1.645c0,3.1,0,4.654-.961,5.617s-2.508.964-5.6.964H8.564c-3.094,0-4.642,0-5.6-.964S2,15.329,2,12.226Z",
    transform: "translate(-2 -2.807)",
    fill: "none",
    stroke: "#3e3b5f",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109505",
    "data-name": "Path 109505",
    d: "M7,3.693V2.5",
    transform: "translate(-2.897 -2.5)",
    fill: "none",
    stroke: "#3e3b5f",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109506",
    "data-name": "Path 109506",
    d: "M17,3.693V2.5",
    transform: "translate(-4.692 -2.5)",
    fill: "none",
    stroke: "#3e3b5f",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109507",
    "data-name": "Path 109507",
    d: "M2.5,9H18.115",
    transform: "translate(-2.102 -3.666)",
    fill: "none",
    stroke: "#3e3b5f",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109508",
    "data-name": "Path 109508",
    d: "M17.59,16.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,17.59,16.8Z",
    transform: "translate(-4.473 -4.884)",
    fill: "#3e3b5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109509",
    "data-name": "Path 109509",
    d: "M17.59,12.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,17.59,12.8Z",
    transform: "translate(-4.473 -4.177)",
    fill: "#3e3b5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109510",
    "data-name": "Path 109510",
    d: "M12.59,16.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,12.59,16.8Z",
    transform: "translate(-3.59 -4.884)",
    fill: "#3e3b5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109511",
    "data-name": "Path 109511",
    d: "M12.59,12.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,12.59,12.8Z",
    transform: "translate(-3.59 -4.177)",
    fill: "#3e3b5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109512",
    "data-name": "Path 109512",
    d: "M7.59,16.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,7.59,16.8Z",
    transform: "translate(-2.707 -4.884)",
    fill: "#3e3b5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109513",
    "data-name": "Path 109513",
    d: "M7.59,12.8a.8.8,0,1,1-.8-.8A.8.8,0,0,1,7.59,12.8Z",
    transform: "translate(-2.707 -4.177)",
    fill: "#3e3b5f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a7a73ae538e4bdde071e5de35a0fcd86.svg";
export { ForwardRef as ReactComponent };